<template>
  <LayoutGradient :title="$t('loinc.import.csv.titulo_pagina')" icon="fa-file-csv">
    <b-card class="mt-n10 steps m-auto" no-body>
      <b-tabs card>
        <b-tab :title="$t('loinc.import.csv.tabs.arquivo.label')" active>
          <b-form class="mt-5">
            <b-form-file
                v-model="file.model"
                :state="Boolean(file)"
                :placeholder="$t('loinc.import.csv.tabs.arquivo.escolha')"
                :drop-placeholder="$t('loinc.import.csv.tabs.arquivo.solte')"
            />
            <div class="mt-3">{{ $t('loinc.import.csv.tabs.arquivo.selecionado') }}: {{ file.model ? file.model.name : '' }}
            </div>
            <b-button variant="info" class="mt-3" @click="loadCSV">{{
                $t('loinc.import.csv.tabs.arquivo.botao_carregar')
              }}
            </b-button>
          </b-form>

          <div v-if="file.progress.load > 0" class="mt-5">
            <h5>{{ $t('loinc.import.csv.tabs.arquivo.carregando') }}</h5>
            <b-progress height="20px" variant="success" striped animated>
              <b-progress-bar :value="file.progress.load"
                              :label="`${((file.progress.load / 100) * 100).toFixed(2)}%`"/>
            </b-progress>
          </div>

          <div v-if="file.progress.prepair > 0" class="mt-5">
            <h5>{{ $t('loinc.import.csv.tabs.arquivo.preparando') }}</h5>
            <b-progress height="20px" variant="success" striped animated>
              <b-progress-bar :value="file.progress.prepair"
                              :label="`${((file.progress.prepair / 100) * 100).toFixed(2)}%`"/>
            </b-progress>
          </div>

          <div v-if="percentageSendind > 0" class="mt-5">
            <h5>{{ $t('loinc.import.csv.tabs.arquivo.enviando') }}</h5>
            <b-progress height="20px" variant="success" striped animated>
              <b-progress-bar :value="percentageSendind"
                              :label="`${percentageSendind.toFixed(2)}%`"/>
            </b-progress>
          </div>
        </b-tab>
        <b-tab :title="$t('loinc.import.csv.tabs.criados.label')">
          <div v-if="created_isLoading || created.length > 0">
            <b-table v-if="created_isLoading" :items="created" :fields="fields">
              <template v-slot:cell(fully_specified_name)="linha">
                <p class="m-0 small" v-if="linha.item.fully_specified_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_longo') }}:</span>
                  {{ linha.item.fully_specified_name }}
                </p>
                <p class="m-0 pt-2 small" v-if="linha.item.short_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_curto') }}:</span>
                  {{ linha.item.short_name }}
                </p>
                <p class="m-0 pt-2 small" v-if="linha.item.long_common_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_exibicao') }}:</span>
                  {{ linha.item.long_common_name }}
                </p>
              </template>
              <template v-slot:cell(status_name)="linha">
                <span
                    :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
                    <em>{{ linha.item.status_name }}</em>
                </span>
              </template>
              <template v-slot:cell(id)="linha">
                <router-link :to="{ name: 'csv.criados.edit', params: { id: linha.item.id }}"
                             class="font-weight-bold">
                  {{ $t('csv.criados.listagem.table.editar') }}
                </router-link>
              </template>
            </b-table>
            <Loading v-else/>
          </div>
          <EmptyData v-else :title="$t('loinc.listagem.table.empty')"/>
        </b-tab>
        <b-tab :title="$t('loinc.import.csv.tabs.atualizados.label')">
          <div body-class="p-0" v-if="updated_isLoading || updated.length > 0">
            <b-table v-if="!updated_isLoading" :items="updated" :fields="fields">
              <template v-slot:cell(fully_specified_name)="linha">
                <p class="m-0 small" v-if="linha.item.fully_specified_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_longo') }}:</span>
                  {{ linha.item.fully_specified_name }}
                </p>
                <p class="m-0 pt-2 small" v-if="linha.item.short_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_curto') }}:</span>
                  {{ linha.item.short_name }}
                </p>
                <p class="m-0 pt-2 small" v-if="linha.item.long_common_name">
                  <span class="font-weight-bold">{{ $t('loinc.listagem.table.nome_exibicao') }}:</span>
                  {{ linha.item.long_common_name }}
                </p>
              </template>
              <template v-slot:cell(status_name)="linha">
                <span
                    :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
                    <em>{{ linha.item.status_name }}</em>
                </span>
              </template>
              <template v-slot:cell(id)="linha">
                <router-link :to="{ name: 'csv.atualizados.edit', params: { id: linha.item.id }}"
                             class="font-weight-bold">
                  {{ $t('csv.atualizados.listagem.table.editar') }}
                </router-link>
              </template>
            </b-table>
            <Loading v-else/>
          </div>
          <EmptyData v-else :title="$t('loinc.listagem.table.empty')"/>
        </b-tab>
      </b-tabs>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import EmptyData from "@/components/EmptyData";
import Loading from "@/components/Loading";
import ImportRepository from "@/repositories/loinc/ImportRepository";
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "importCSV",
  components: {Loading, EmptyData, LayoutGradient},
  computed: {
    ...mapGetters({
      created: 'loinc/importCSV/allCreated',
      created_pagination: 'loinc/importCSV/paginationCreated',
      created_isLoading: 'loinc/importCSV/isLoadingCreated',
      updated: 'loinc/importCSV/allUpdated',
      updated_pagination: 'loinc/importCSV/paginationUpdated',
      updated_isLoading: 'loinc/importCSV/isLoadingUpdated',
    }),
    percentageSendind() {
      if (this.file.progress.sending.current / this.file.progress.sending.total) {
        return ((this.file.progress.sending.current / this.file.progress.sending.total) * 100)
      }
      return 0.00
    }
  },
  data() {
    return {
      file: {
        model: null,
        progress: {
          load: 0,
          prepair: 0,
          sending: {
            current: 0,
            total: 0,
          },
        },
        line_per_time: 3000,
        csvHeader: null,
        csvList: []
      },
      fields: [
        {key: 'loinc', label: 'LOINC'},
        {key: 'fully_specified_name', label: this.$t('loinc.listagem.table.nome')},
        {key: 'short_name', label: this.$t('loinc.listagem.table.nome_curto')},
        {key: 'long_common_name', label: this.$t('loinc.listagem.table.nome_exibicao')},
        {key: 'component', label: this.$t('loinc.listagem.table.componente')},
        {key: 'property', label: this.$t('loinc.listagem.table.propriedade')},
        {key: 'time', label: this.$t('loinc.listagem.table.tempo')},
        {key: 'system', label: this.$t('loinc.listagem.table.sistema')},
        {key: 'scale', label: this.$t('loinc.listagem.table.escala')},
        {key: 'method', label: this.$t('loinc.listagem.table.metodo')},
        {key: 'order_observation_name', label: this.$t('loinc.listagem.table.ordem_observacao')},
        {key: 'status_name', label: 'Status'},
        {key: 'id', label: this.$t('loinc.listagem.table.editar')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'loinc/importCSV/listAllCreated',
      'loinc/importCSV/listAllUpdated',
      'loinc/importCSV/resetAll',
    ]),
    async loadCSV() {
      try {
        this.file.progress.load = 0
        this.file.progress.prepair = 0
        this.file.progress.sending.current = 0
        this.file.progress.sending.total = 0
        await ImportRepository.cleanAll()
        this.file.progress.load = 25
        await this['loinc/importCSV/resetAll']()

        let reader = new FileReader();
        reader.readAsText(this.file.model);

        this.file.progress.load = 50
        reader.onload = this.setFile;
        reader.onerror = this.errorHandler;
      } catch (e) {
        console.log('exception on loadCSV', e)
        this.$snotify.error(this.$t('loinc.import.csv.erro.carregar'))
      }
    },
    errorHandler(event) {
      console.log('errorHandler', event);
    },
    setFile(event) {
      this.file.progress.load = 100
      let csv = event.target.result

      //filter used to remove empty string on the end of the array;
      this.file.csvList = csv.split(/\r\n|\n/).filter(v => v !== '')
      this.file.progress.prepair = 5

      //split the header and store
      this.file.csvHeader = this.file.csvList.splice(0, 1)
      this.file.csvHeader = this.file.csvHeader[0].split(',')

      this.file.progress.sending.total = this.file.csvList.length

      let currentPrepair = 0;
      const array = this.file.csvList.map(line => {
        currentPrepair += 1
        this.file.progress.prepair = (currentPrepair * 100) / this.file.progress.sending.total
        return line.split(',')
      })

      this.file.csvList = array

      this.processFile();
    },
    processFile() {
      try {
        if (this.file.csvList.length > 0) {
          const arrayLength = (this.file.csvList.length < this.file.line_per_time) ? this.file.csvList.length : this.file.line_per_time
          const lines = this.file.csvList.splice(0, arrayLength)

          const lines_with_header = [this.file.csvHeader, ...lines]

          this.import(lines_with_header, lines.length);
        } else {
          this['loinc/importCSV/listAllCreated'](this.created_pagination)
          this['loinc/importCSV/listAllUpdated'](this.updated_pagination)
        }
      } catch (e) {
        console.log("exception on processFile", e)
        this.$snotify.error(this.$t('loinc.import.csv.erro.processar'))
      }
    },
    import(loincs, lines_quantity) {
      this.file.progress.sending.current += lines_quantity

      ImportRepository.import({loinc_csv: loincs})
          .then(() => this.processFile())
          .catch(error => {
            console.log(error)
            this.$snotify.error(this.$t('loinc.import.csv.erro.enviar'))
          })
    }
  },
  mounted() {
    this['loinc/importCSV/resetAll']()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .steps {
  @media only screen and (min-width: 600px) {
    width: 75% !important;
  }
}

@media only screen and (min-width: 600px) {
  .width-75 {
    width: 75% !important;
  }
}
</style>